// extracted by mini-css-extract-plugin
module.exports = {"default":"_type_default__n2VBi"};